function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M320 219.045h-42.667L256 182.094l-21.333 36.95H192l21.335 36.951L192 292.944h42.667L256 329.895l21.333-36.95H320l-21.335-36.951L320 219.045zm-37.791 36.949l-13.104 22.699h-26.209l-13.105-22.699 13.105-22.699h26.209l13.104 22.699zM256 210.597l4.877 8.448h-9.754l4.877-8.448zm-39.315 22.698h9.755l-4.877 8.448-4.878-8.448zm0 45.399l4.877-8.448 4.877 8.448h-9.754zM256 301.392l-4.876-8.448h9.754L256 301.392zm39.315-22.698h-9.755l4.877-8.448 4.878 8.448zm-9.755-45.399h9.755l-4.877 8.448-4.878-8.448zM0 106.657h512v42.663H0zm0 256h512v42.663H0z",
  fill: "#2e52b2"
});

const SvgIsrael = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIsrael, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/israel.c6c7bcae.svg";
export { ForwardRef as ReactComponent };